import { render, staticRenderFns } from "./distribution-scope-modal.vue?vue&type=template&id=6ba08234&scoped=true"
import script from "./distribution-scope-modal.vue?vue&type=script&lang=js"
export * from "./distribution-scope-modal.vue?vue&type=script&lang=js"
import style0 from "./distribution-scope-modal.vue?vue&type=style&index=0&id=6ba08234&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba08234",
  null
  
)

export default component.exports